import get from 'lodash.get';

export const createLeadTransformer = (
  data: Record<string, unknown>
): string => {
  return get(data, 'lead_identifier', '') as string;
};

export const companySearchTransformer = (
  data: string
): Array<{ value: string; label: string }> => {
  try {
    data = JSON.parse(data);
  } catch (error) {
    console.log(error);
    return [];
  }
  if (!Array.isArray(data)) return [];
  return data.map((companyData: string): { value: string; label: string } => {
    const company_name = get(companyData, 'legalName', '');
    return { value: company_name, label: company_name };
  });
};
